<template>
  <div class="not-found-container">
    <div class="loading-container">
      <img class="pic-404__parent" src="../assets/img/not-found.svg" alt="404">
      <h1>{{ statusText }}</h1>
      <div class="btn-row">
        <el-button size="small" type="primary" v-if="showLogin" @click="goLogin">重新登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'notFound',
  data() {
    return {
      statusText: '抱歉! 您所访问的页面不存在或无权查看',
      /**暂时登录按钮 */
      showLogin: false,
    }
  },
  mounted() {
    console.log('mounted----', this.$route.query)
    // 支持路由携带文本内容展示
    if (this.$route.query) {
       // 判断statusText 是不是中文 含有中文都行
      if (this.$route.query.statusText && /[\u4e00-\u9fa5]/.test(this.$route.query.statusText)) {
        this.statusText = this.$route.query.statusText
      } else {
        this.statusText = '抱歉! 您所访问的页面不存在或无权查看'
      }
      this.$route.query.showLogin ? this.showLogin = this.$route.query.showLogin : ''
    }

  },
  methods: {
    goLogin() {
      localStorage.removeItem("Authorization");
      localStorage.removeItem("url");
      localStorage.removeItem("routerList");
      localStorage.removeItem("myDepartment");
      localStorage.removeItem("userId");
      this.$router.push({ path: '/login' })
    }
  }
}
</script>

<style lang="scss" scoped>
.not-found-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;


  .loading-container {
    text-align: center;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h1 {
      font-size: 22px;
      font-weight: 600;
    }
  }



  .btn-row {
    margin-top: 5px;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;



    .btn-home {

      color: #fff;
      background-color: #267EF0;
      width: fit-content;
      padding: 8px 30px;
      border-radius: 999px;
      font-size: 16px;

      .icon-home {
        font-size: 16px !important;
      }

      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>